export default function calcCustomerPOReference(documentReferences) {
  let customerPOReference = "";
  if (documentReferences) {
    if (documentReferences.CustomerPOReference)
      customerPOReference = documentReferences.CustomerPOReference.value;
    else {
      documentReferences.forEach((ref) => {
        if (ref.description === "CustomerPOReference") {
          customerPOReference = ref.value;
        }
      });
    }
  }
  return customerPOReference;
}
